import {NgModule} from '@angular/core';
import {FormValueConverter} from "./api/entity/converter/formValue.converter";

@NgModule({
    providers: [
        FormValueConverter,
    ]
})
export class FormValueModule {
}
